import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted, onBeforeUnmount } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToTopButton',
  props: {
    visibleY: {}
  },
  setup(__props: any) {

const isVisible = ref(false);
const props = __props;

onMounted(() => {
    window.addEventListener("scroll", checkIsVisible);
});
onBeforeUnmount(() => {
    window.removeEventListener("scroll", checkIsVisible);
});

function checkIsVisible() {
    isVisible.value = props.visibleY < window.scrollY;
}
// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (topFunction())),
        class: "topBtn",
        "aria-label": "Go to top"
      }, " ↑ "))
    : _createCommentVNode("", true)
}
}

})